/* Melina capture popup — symptom Q → email → SMS (skippable) → success.
   Klaviyo client API (same split-payload + retry-queue pattern as the quiz),
   PostHog funnel events, localStorage suppression. */
(function () {
  'use strict';

  var ROOT = document.getElementById('mp-root');
  var CFG = window.MP_CONFIG || {};
  if (!ROOT || !CFG.klaviyoPublicKey || !CFG.klaviyoListId) return;

  var LS_STATE = 'mp:state:' + CFG.popupId;
  var LS_QUEUE = 'mp:email_queue';
  var DAY = 86400000;

  /* ---------- state ---------- */
  function readState() {
    try { return JSON.parse(localStorage.getItem(LS_STATE) || 'null') || {}; }
    catch (e) { return {}; }
  }
  function writeState(patch) {
    var s = readState();
    for (var k in patch) s[k] = patch[k];
    try { localStorage.setItem(LS_STATE, JSON.stringify(s)); } catch (e) {}
    return s;
  }

  /* ---------- analytics ---------- */
  function ph(name, props) {
    try {
      if (window.posthog && typeof window.posthog.capture === 'function') {
        var merged = { popup_id: CFG.popupId, popup_version: CFG.version };
        for (var k in (props || {})) merged[k] = props[k];
        window.posthog.capture(name, merged);
      }
    } catch (e) {}
  }

  /* ---------- suppression ---------- */
  function klaviyoIdentified() {
    // __kla_id exists for anonymous visitors too; only an $exchange_id (set on
    // email-link click-through or an identify call) marks a known profile.
    try {
      var m = document.cookie.match(/(?:^|;\s*)__kla_id=([^;]+)/);
      if (!m) return false;
      var obj = JSON.parse(atob(decodeURIComponent(m[1])));
      return !!(obj && (obj.$exchange_id || obj.$email));
    } catch (e) { return false; }
  }
  function quizCaptured() {
    // The quiz writes mq:completed:<quizId> after its email step.
    try {
      for (var i = 0; i < localStorage.length; i++) {
        if ((localStorage.key(i) || '').indexOf('mq:completed:') === 0) return true;
      }
    } catch (e) {}
    return false;
  }
  var klFormOpen = false;
  window.addEventListener('klaviyo-forms', function (e) {
    var t = e && e.detail && e.detail.type;
    if (t === 'open') klFormOpen = true;
    if (t === 'close') klFormOpen = false;
  });
  function suppressed() {
    var s = readState();
    if (s.status === 'submitted') return 'submitted';
    if (s.status === 'dismissed' && (Date.now() - (s.ts || 0)) < (CFG.dismissedCooldownDays || 5) * DAY) return 'cooldown';
    if (CFG.suppressIfKlaviyoIdentified && klaviyoIdentified()) return 'klaviyo_identified';
    if (quizCaptured()) return 'quiz_captured';
    if (signedUpElsewhere()) return 'submitted_other_popup';
    return null;
  }
  function signedUpElsewhere() {
    // A signup in any other Melina popup (Mighty <-> Everbright) hides this one for
    // crossSignupCooldownDays (default 30). Laila, 2026-09-24.
    var win = (CFG.crossSignupCooldownDays || 30) * DAY;
    try {
      for (var i = 0; i < localStorage.length; i++) {
        var k = localStorage.key(i) || '';
        if (k.indexOf('mp:state:') !== 0 || k === LS_STATE) continue;
        var o = JSON.parse(localStorage.getItem(k) || 'null');
        if (o && o.status === 'submitted' && (Date.now() - (o.ts || 0)) < win) return true;
      }
    } catch (e) {}
    return false;
  }

  /* ---------- Klaviyo retry queue (quiz pattern) ---------- */
  function readQueue() {
    try { return JSON.parse(localStorage.getItem(LS_QUEUE) || '[]'); }
    catch (e) { return []; }
  }
  function writeQueue(q) {
    try { localStorage.setItem(LS_QUEUE, JSON.stringify(q)); } catch (e) {}
  }
  var flushing = false;
  function flushQueue() {
    if (flushing) return;
    var queue = readQueue();
    if (!queue.length) return;
    flushing = true;
    var item = queue[0];
    fetch(item.url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'revision': '2025-04-15' },
      body: JSON.stringify(item.payload),
    }).then(function (r) {
      flushing = false;
      if (r.ok || (r.status >= 400 && r.status < 500)) {
        // 2xx drained; 4xx malformed — drop so it can't wedge the queue.
        var q = readQueue(); q.shift(); writeQueue(q);
        flushQueue();
      }
    }).catch(function () { flushing = false; /* retry next flush */ });
  }
  function enqueue(path, payload) {
    var q = readQueue();
    q.push({
      url: 'https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(CFG.klaviyoPublicKey),
      payload: payload, attempts: 0, ts: Date.now(),
    });
    writeQueue(q);
    flushQueue();
  }

  function profileProperties(answer) {
    var p = { popup_id: CFG.popupId, popup_version: CFG.version, popup_page: location.pathname };
    if (answer) p.popup_answer = answer;
    return p;
  }
  function submitEmail(email, answer) {
    enqueue('profiles', { data: { type: 'profile', attributes: {
      email: email, properties: profileProperties(answer),
    } } });
    // Omitting `subscriptions` defaults consent to MARKETING for the channels
    // present — the list-relationship POST IS the consent action (quiz pattern).
    enqueue('subscriptions', { data: {
      type: 'subscription',
      attributes: { custom_source: 'Popup — ' + CFG.popupId, profile: { data: { type: 'profile', attributes: { email: email } } } },
      relationships: { list: { data: { type: 'list', id: CFG.klaviyoListId } } },
    } });
    // Fire-and-forget event; the subscription POST is the durable one.
    try {
      fetch('https://a.klaviyo.com/client/events/?company_id=' + encodeURIComponent(CFG.klaviyoPublicKey), {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'revision': '2025-04-15' },
        body: JSON.stringify({ data: { type: 'event', attributes: {
          properties: profileProperties(answer),
          metric: { data: { type: 'metric', attributes: { name: 'Popup Signup' } } },
          profile: { data: { type: 'profile', attributes: { email: email } } },
        } } }),
      }).catch(function () {});
    } catch (e) {}
    try {
      if (window.posthog && typeof window.posthog.identify === 'function') window.posthog.identify(email);
    } catch (e) {}
  }
  function submitPhone(email, phone, answer) {
    enqueue('profiles', { data: { type: 'profile', attributes: {
      email: email, phone_number: phone, properties: profileProperties(answer),
    } } });
    enqueue('subscriptions', { data: {
      type: 'subscription',
      attributes: { custom_source: 'Popup — ' + CFG.popupId, profile: { data: { type: 'profile', attributes: { email: email, phone_number: phone } } } },
      relationships: { list: { data: { type: 'list', id: CFG.klaviyoListId } } },
    } });
  }

  /* ---------- validation ---------- */
  function validEmail(v) { return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(v); }
  /* melina-email-check v1. Same copy in every Melina email form; source: scripts/email_check/email_check.js.
     Returns null when the address may go through, or the message to show under the field.
     Runs after each form's own format regex. Any error lets the address through. */
  function melinaEmailProblem(email) {
    try {
      var raw = String(email || '').trim();
      var at = raw.lastIndexOf('@');
      if (at < 1) return null;
      var local = raw.slice(0, at).toLowerCase();
      var domain = raw.slice(at + 1).toLowerCase();
      var typos = {
        'gmail.co': 'gmail.com', 'gmail.cm': 'gmail.com', 'gmail.om': 'gmail.com', 'gmail.cmo': 'gmail.com',
        'gmail.comm': 'gmail.com', 'gmail.cpm': 'gmail.com', 'gmail.vom': 'gmail.com', 'gmail.xom': 'gmail.com',
        'gmai.com': 'gmail.com', 'gmial.com': 'gmail.com', 'gnail.com': 'gmail.com', 'gamil.com': 'gmail.com',
        'gmaill.com': 'gmail.com', 'gmal.com': 'gmail.com', 'gmil.com': 'gmail.com', 'gmali.com': 'gmail.com',
        'hotmail.co': 'hotmail.com', 'hotmail.cm': 'hotmail.com', 'hotmial.com': 'hotmail.com', 'hotmal.com': 'hotmail.com',
        'yahoo.co': 'yahoo.com', 'yahoo.cm': 'yahoo.com', 'yaho.com': 'yahoo.com', 'yahooo.com': 'yahoo.com',
        'outlook.co': 'outlook.com', 'outlook.cm': 'outlook.com', 'outlok.com': 'outlook.com',
        'icloud.co': 'icloud.com', 'icloud.cm': 'icloud.com', 'iclod.com': 'icloud.com', 'icoud.com': 'icloud.com',
        'aol.co': 'aol.com', 'aol.cm': 'aol.com'
      };
      var fix = typos[domain] || (/\.con$/.test(domain) ? domain.slice(0, -4) + '.com' : null);
      if (fix) return 'Did you mean ' + raw.slice(0, at) + '@' + fix + '?';
      /* Gmail ignores dots, so bots sign one inbox up many times as j.o.h.n.do.e@gmail.com.
         None of our 6,688 buyers had 4 or more dots before a Gmail @ (checked 2026-10-04). */
      if ((domain === 'gmail.com' || domain === 'googlemail.com') && local.split('.').length > 4) {
        return 'Please enter a valid email address.';
      }
      return null;
    } catch (err) {
      return null;
    }
  }
  function normalizePhone(v) {
    var d = (v || '').replace(/\D/g, '');
    if (d.length === 10) return '+1' + d;
    if (d.length === 11 && d.charAt(0) === '1') return '+' + d;
    if (/^\+/.test((v || '').trim()) && d.length >= 8 && d.length <= 15) return '+' + d;
    return null;
  }

  /* ---------- UI ---------- */
  var PANELS = {};
  ['question', 'email', 'sms', 'success'].forEach(function (n) {
    PANELS[n] = ROOT.querySelector('[data-mp-step="' + n + '"]');
  });
  var currentStep = 'question';
  function showStep(name) {
    for (var k in PANELS) { if (PANELS[k]) PANELS[k].hidden = (k !== name); }
    currentStep = name;
    var stage = ROOT.querySelector('.mp-stage');
    if (stage) stage.scrollTop = 0;
  }
  function openPopup() {
    var s = readState();
    ROOT.classList.add('is-open');
    ROOT.removeAttribute('aria-hidden');
    document.documentElement.classList.add('mp-lock');
    showStep(s.answer ? 'email' : 'question');
    ph('popup_viewed', { step: currentStep });
    var overlay = ROOT.querySelector('.mp-overlay');
    if (overlay) overlay.focus({ preventScroll: true });
  }
  function closePopup(reason) {
    ROOT.classList.remove('is-open');
    ROOT.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('mp-lock');
    var s = readState();
    if (s.status !== 'submitted') writeState({ status: 'dismissed', ts: Date.now() });
    if (reason !== 'finished') ph('popup_dismissed', { step: currentStep });
  }

  /* ---------- wiring ---------- */
  ROOT.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('.mp-close')) { closePopup('x'); return; }

    var pill = t.closest('.mp-pill');
    if (pill) {
      var answer = pill.getAttribute('data-mp-answer') || pill.textContent.trim();
      writeState({ status: 'partial', answer: answer, ts: Date.now() });
      ph('popup_answer_tapped', { answer: answer });
      showStep('email');
      var em = ROOT.querySelector('#mp-email-input');
      if (em) em.focus();
      return;
    }

    if (t.closest('[data-mp-action="skip-sms"]')) {
      ph('popup_sms_skipped', {});
      showStep('success');
      return;
    }
    if (t.closest('[data-mp-action="finish"]')) {
      closePopup('finished');
      // never leave the site menu drawer open over the buy box
      try {
        document.querySelectorAll('#mg-nav.is-open, #mh-nav.is-open').forEach(function (n) {
          n.classList.remove('is-open');
          var b = n.querySelector('[aria-expanded]'); if (b) b.setAttribute('aria-expanded', 'false');
        });
      } catch (err) {}
      // Anchor back to the listicle buy box (visible view only — desktop and
      // mobile each render their own .ml-buybox, one is display:none).
      try {
        var boxes = document.querySelectorAll('.ml-buybox');
        for (var i = 0; i < boxes.length; i++) {
          if (boxes[i].offsetParent !== null) { boxes[i].scrollIntoView({ behavior: 'smooth', block: 'start' }); break; }
        }
      } catch (err) {}
      return;
    }
  });

  var emailForm = ROOT.querySelector('#mp-email-form');
  if (emailForm) emailForm.addEventListener('submit', function (e) {
    e.preventDefault();
    var input = ROOT.querySelector('#mp-email-input');
    var err = ROOT.querySelector('#mp-email-error');
    var v = (input && input.value || '').trim();
    var problem = validEmail(v) ? melinaEmailProblem(v) : null;
    if (!validEmail(v) || problem) {
      if (err) {
        if (err.getAttribute('data-default') === null) err.setAttribute('data-default', err.textContent);
        err.textContent = problem || err.getAttribute('data-default');
        err.classList.add('is-visible');
      }
      if (input) input.focus();
      return;
    }
    if (err) err.classList.remove('is-visible');
    var s = writeState({ status: 'submitted', email: v, ts: Date.now() });
    submitEmail(v, s.answer);
    ph('popup_email_submitted', { answer: s.answer });
    showStep('sms');
    var pn = ROOT.querySelector('#mp-phone-input');
    if (pn) pn.focus();
  });

  var smsForm = ROOT.querySelector('#mp-sms-form');
  if (smsForm) smsForm.addEventListener('submit', function (e) {
    e.preventDefault();
    var input = ROOT.querySelector('#mp-phone-input');
    var err = ROOT.querySelector('#mp-phone-error');
    var phone = normalizePhone(input && input.value);
    if (!phone) {
      if (err) err.classList.add('is-visible');
      if (input) input.focus();
      return;
    }
    if (err) err.classList.remove('is-visible');
    var s = readState();
    submitPhone(s.email, phone, s.answer);
    ph('popup_sms_submitted', {});
    showStep('success');
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && ROOT.classList.contains('is-open')) closePopup('esc');
  });

  /* ---------- takeover detection (cart drawer, menu drawer, any body-locking modal) ---------- */
  function takeoverOpen() {
    try {
      if (document.body.classList.contains('overflow-hidden')) return true;
      // Melina site menu (sticky header drawer): opening over it left the drawer pinned open (2026-09-24).
      if (document.querySelector('#mg-nav.is-open, #mh-nav.is-open')) return true;
      var drawer = document.querySelector('cart-drawer');
      if (drawer && drawer.classList.contains('active')) return true;
    } catch (e) {}
    return false;
  }
  // Yield right-of-way: wait for the takeover to close, then re-attempt after a
  // grace period. tryOpen re-checks everything, so a re-opened cart defers again.
  function deferUntilTakeoverClosed() {
    try { console.info('[melina-popup] deferred: takeover open (cart/menu/modal)'); } catch (e) {}
    var mo = new MutationObserver(function () {
      if (takeoverOpen()) return;
      mo.disconnect();
      setTimeout(tryOpen, CFG.takeoverGraceMs || 7000);
    });
    mo.observe(document.body, { attributes: true, attributeFilter: ['class'] });
    var drawer = document.querySelector('cart-drawer');
    if (drawer) mo.observe(drawer, { attributes: true, attributeFilter: ['class'] });
    document.querySelectorAll('#mg-nav, #mh-nav').forEach(function (n) {
      mo.observe(n, { attributes: true, attributeFilter: ['class'] });
    });
  }

  /* ---------- boot ---------- */
  flushQueue(); // drain anything left from a previous session
  // ?mp_force=1 → QA override: skip suppression, open after 1s.
  var force = /[?&]mp_force=1/.test(location.search);
  var why = force ? null : suppressed();
  if (why) {
    try { console.info('[melina-popup] suppressed: ' + why); } catch (e) {}
    return;
  }
  function tryOpen() {
    if (!force) {
      var w = suppressed();      // state may have changed since load
      if (!w && klFormOpen) w = 'native_klaviyo_form_open';
      if (w) {
        try { console.info('[melina-popup] suppressed: ' + w); } catch (e) {}
        return;
      }
    }
    if (takeoverOpen()) { deferUntilTakeoverClosed(); return; }
    openPopup();
  }
  setTimeout(tryOpen, force ? 1000 : (CFG.delayMs || 10000));
})();
